export default "__VITE_ASSET__ByTQ7sLw__"